/**
 * Standard paginated API response envelope.
 */
export interface PaginatedMeta {
  current_page: number
  last_page: number
  per_page?: number
  total?: number
}

export interface PaginatedApiResponse<T> {
  data: T[]
  meta: PaginatedMeta
}

/**
 * Laravel paginator shape (legacy — top-level pagination fields).
 */
export interface LaravelPaginatorResponse<T> {
  data: T[]
  current_page: number
  last_page: number
  per_page?: number
  total?: number
}

/**
 * Normalize paginated API responses from either envelope format.
 */
export function parsePaginatedResponse<T>(
  body: PaginatedApiResponse<T> | LaravelPaginatorResponse<T>
): { items: T[]; currentPage: number; lastPage: number } {
  if ('meta' in body && body.meta) {
    return {
      items: body.data,
      currentPage: body.meta.current_page,
      lastPage: body.meta.last_page,
    }
  }

  const legacy = body as LaravelPaginatorResponse<T>

  return {
    items: legacy.data,
    currentPage: legacy.current_page,
    lastPage: legacy.last_page,
  }
}
